import { FC, PropsWithChildren, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SettingsMenuContext, SettingsTab } from './SettingsMenuContext';
import { 
    SettingsConversationsRoute,
    SettingsUserManagementRoute,
    SettingsSurveysRoute,
    SettingsSurveysEditRoute,
    SettingsSurveysViewRoute
} from '../Routes';

export const SettingsMenuContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [isInSettings, setIsInSettings] = useState(false);
    const [activeTab, setActiveTab] = useState<SettingsTab>('general');
    const [previousRoute, setPreviousRoute] = useState<string | null>(null);
    const location = useLocation();
    const navigate = useNavigate();

    // Sync activeTab with the current URL
    useEffect(() => {
        const path = location.pathname;
        
        if (path.startsWith('/settings/surveys/edit') || 
            path.startsWith('/settings/surveys/view') || 
            path === '/settings/surveys/new') {
            setActiveTab('surveys');
        } else if (path === SettingsConversationsRoute) {
            setActiveTab('conversations');
        } else if (path === SettingsUserManagementRoute) {
            setActiveTab('user-management');
        } else if (path === SettingsSurveysRoute) {
            setActiveTab('surveys');
        } else if (path.startsWith('/settings')) {
            setActiveTab('conversations'); // default
        }
    }, [location.pathname]);

    return (
        <SettingsMenuContext.Provider value={{ isInSettings, setIsInSettings, activeTab, setActiveTab, previousRoute, setPreviousRoute }}>
            {children}
        </SettingsMenuContext.Provider>
    );
};
